import { EtfDetails } from '@/components/Stocks/Widgets/types'

export const getETFNavItems = ({
  etf_details,
}: {
  etf_details?: EtfDetails
}) => {
  const { summary, insights_data, research } = etf_details ?? {}

  const { infographics } = research ?? {}

  return [
    { id: 'share-price', label: 'Share Price' },
    {
      id: 'fundamentals',
      label: 'Fundamentals',
    },
    (!!insights_data || !!infographics?.heading) && {
      id: 'news',
      label: 'News',
    },
    summary?.description && {
      id: 'company-info',
      label: 'Company Info',
    },
    {
      id: 'faqs',
      label: 'FAQs',
    },
  ].filter(Boolean) as { id: string; label: string }[]
}
